export interface SpecialArticle {
  id: string;
  title: string;
  summary: string;
  date: string;
  author: string;
  content: string[];
}

export interface Special {
  id: string;
  title: string;
  cover: string;
  intro: string;
  date: string;
  author: string;
  tags: string[];
  articles: SpecialArticle[];
}

export const specials: Special[] = [
  {
    id: "chinese-suspense-golden-age",
    title: "华语悬疑剧的黄金时代",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20feature%20banner%20about%20chinese%20mystery%20television%2C%20dark%20rainy%20city%20skyline%20at%20night%20with%20warm%20orange%20window%20lights%2C%20deep%20navy%20cinematic%20tone%2C%20moody%20sophisticated%20magazine%20aesthetic%2C%20abstract%20stylized%20illustration&width=1200&height=675&seq=marie-special-01&orientation=landscape",
    intro: "从零散的单元剧到结构严密的长篇叙事，华语悬疑剧用了不到十年走完了别人几十年的路。本专题集合四篇长评，试图回答一个问题：当观众不再满足于「谁是凶手」，悬疑剧还能讲什么？",
    date: "2026-09-30",
    author: "影志编辑部",
    tags: ["悬疑剧", "华语影视", "深度长评"],
    articles: [
      {
        id: "a1",
        title: "从解谜到共情：悬疑剧的叙事重心正在转移",
        summary: "当真相不再是终点，悬疑剧开始把镜头对准案件背后的社会肌理与人性褶皱。",
        date: "2026-09-30",
        author: "影志小编",
        content: [
          "过去十年，华语悬疑剧最大的变化，不是尺度的放宽，而是叙事重心的迁移。早期的悬疑剧把「谁是凶手」当作唯一目标，观众跟着主角一路收集线索，直到最后一集揭晓谜底，任务结束。",
          "而近几年的作品开始意识到，谜底揭晓的那一刻，故事其实才刚刚开始。真正的悬念不在于凶手是谁，而在于——为什么会有这样的凶手，这样的受害者，这样的旁观者。",
          "《雾港之谜》之所以让人印象深刻，正是因为它几乎没有真正的反派。每个人都在自己的处境里做出了当时看来最合理的选择，而这些合理的选择叠加在一起，最终酿成了一场无法挽回的悲剧。",
          "这不是对犯罪的宽容，而是一种更深的理解：悬疑剧的价值，从来不只是让观众猜对答案，而是让观众在下一次面对现实时，多一分迟疑与共情。",
        ],
      },
      {
        id: "a2",
        title: "空间即人物：为什么好悬疑剧都懂得用环境说话",
        summary: "雨夜、海雾、旧城区——环境从来不是背景板，而是参与叙事的隐形角色。",
        date: "2026-09-28",
        author: "夜航评论",
        content: [
          "优秀的悬疑剧往往有一个共同点：它让你在剧情开始之前，就已经感到不安。这种不安不是来自配乐，而是来自空间。",
          "潮湿的街道、过分安静的旧楼、永远雾气弥漫的港口——这些空间本身就在暗示：这里发生过一些不想被人记住的事。",
          "空间塑造的另一个作用，是压缩角色的活动范围。当人物被困在一个封闭的、被监视的、无法逃离的环境里，他的每一次选择都会变得更重。观众看得越压抑，最后爆发的冲击就越强。",
          "所以当我们夸一部悬疑剧「氛围感好」时，我们其实在夸它的世界观立住了。氛围不是装饰，而是叙事的骨架。",
        ],
      },
      {
        id: "a3",
        title: "群像时代：配角终于不再是工具人",
        summary: "当每个配角都拥有独立动机，悬疑剧才真正拥有了可信的世界。",
        date: "2026-09-25",
        author: "剧评人·老K",
        content: [
          "很长一段时间里，悬疑剧的配角只有两种功能：提供线索，或者被牺牲。他们的存在是为了推动主角前进，本身没有自己的时间。",
          "但近年的作品打破了这一点。配角开始拥有独立的家庭、困境和判断，他们不再被动地等待剧情降临，而是主动做出选择，哪怕这个选择把整条故事线推向更糟的方向。",
          "这让悬疑剧的复杂度成倍增加，也让观众的代入感变得更强——因为你永远不知道，下一个做出错误决定的人会不会就是你自己。",
        ],
      },
      {
        id: "a4",
        title: "节奏的克制：为什么好故事不需要一直高潮",
        summary: "留白与停顿，是悬疑剧最容易被忽视、也最珍贵的能力。",
        date: "2026-09-22",
        author: "悬疑片观察室",
        content: [
          "流媒体时代的悬疑剧面临一个尴尬：观众注意力被无限切碎，很多作品因此不敢停下来，恨不得每一分钟都塞进一个反转。",
          "但真正的好故事懂得留白。它允许角色沉默，允许镜头停留在空房间里，允许观众自己拼凑那些没有被说出口的部分。",
          "克制不是慢，而是相信观众。当创作者敢于相信观众的理解力，观众往往会回报以更深的投入。",
        ],
      },
    ],
  },
  {
    id: "time-philosophy-in-scifi",
    title: "科幻电影中的时间哲学",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20feature%20banner%20about%20science%20fiction%20and%20time%2C%20abstract%20glowing%20concentric%20rings%20and%20light%20trails%20in%20deep%20navy%20space%20with%20vivid%20orange%20highlights%2C%20elegant%20minimal%20magazine%20aesthetic%2C%20stylized%20illustration&width=1200&height=675&seq=marie-special-02&orientation=landscape",
    intro: "时间旅行是科幻电影最古老的玩具，也是最难驾驭的命题。本专题不谈硬核物理，只谈当一个故事敢让时间折叠时，它究竟在追问我们什么。",
    date: "2026-09-18",
    author: "硬核科幻谈",
    tags: ["科幻", "时间", "影评"],
    articles: [
      {
        id: "b1",
        title: "如果结局早已注定，我们还要不要努力",
        summary: "时间循环题材真正的魅力，从来不在于怎么逃出去，而在于为什么值得再试一次。",
        date: "2026-09-18",
        author: "硬核科幻谈",
        content: [
          "时间循环是科幻叙事里最讨巧也最危险的结构。讨巧在于，它天然自带悬念；危险在于，它极易沦为重复的游戏，让观众在第一轮之后就失去耐心。",
          "那些真正立得住的循环故事，都解决了同一个问题：让每一轮都产生不可逆的变化。角色记住的东西、失去的东西、改变的东西，不会因为时间重置而消失。",
          "换句话说，它用超自然的设定，讲了最普通的一件事——即使命运不断把我们推回原点，我们仍然愿意再试一次。这份固执，才是打动人心的东西。",
        ],
      },
      {
        id: "b2",
        title: "记忆是不是我们唯一的身份",
        summary: "当记忆可以被移植、复制甚至伪造，我们凭什么确认自己还是原来的人。",
        date: "2026-09-15",
        author: "科幻观察",
        content: [
          "大量科幻作品反复回到同一个哲学起点：如果记忆可以脱离身体而存在，那么「我」究竟是什么。",
          "有些作品给出浪漫的答案——只要记忆延续，爱就没有终结。另一些作品则更冷峻——记忆不过是数据，可以被复制，也就意味着可以被篡改、被替代。",
          "这两种答案的冲突，恰恰是科幻电影最有价值的思辨空间。它不提供结论，只是把问题推到你面前，让你在观影之后继续思考。",
        ],
      },
      {
        id: "b3",
        title: "孤独是科幻恒久不变的主题",
        summary: "在无限广阔的宇宙里，人类最深的恐惧与最深的浪漫，都源自孤独。",
        date: "2026-09-12",
        author: "影志小编",
        content: [
          "科幻电影最擅长的构图里，总有一个渺小的身影，面对着过于庞大的背景——星空、星球、废墟。",
          "这种尺度的对比，本质上是孤独的视觉化。它提醒我们，在浩瀚的时间与空间面前，人如此短暂，如此孤立。",
          "但正因为孤独被推到极致，人与人之间的每一次连接才显得格外珍贵。科幻最动人的时刻，往往是两个孤独的灵魂，在宇宙的尽头仍选择走向彼此。",
        ],
      },
    ],
  },
  {
    id: "korean-realism-drama",
    title: "韩国现实主义剧集观察",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20feature%20banner%20about%20korean%20realist%20drama%2C%20quiet%20seoul%20apartment%20alley%20at%20dusk%20with%20warm%20orange%20window%20glow%20against%20deep%20navy%20shadows%2C%20subtle%20documentary%20aesthetic%2C%20stylized%20illustration&width=1200&height=675&seq=marie-special-03&orientation=landscape",
    intro: "韩国剧集最被低估的能力，不是爱情，而是对普通人处境近乎残酷的诚实。本专题从医疗、家庭与阶层三个切面，观察韩国现实主义剧集为何总能击中人心。",
    date: "2026-09-06",
    author: "韩剧急诊室",
    tags: ["韩剧", "现实主义", "社会观察"],
    articles: [
      {
        id: "c1",
        title: "被误解的「治愈」：韩国剧集里的温暖有何不同",
        summary: "真正的治愈，不是消除痛苦，而是承认痛苦存在之后依然选择生活。",
        date: "2026-09-06",
        author: "韩剧急诊室",
        content: [
          "很多人以为韩剧的治愈就是甜，其实恰恰相反。它最擅长的，是先让你看见伤口，再告诉你伤口可以不用那么快愈合。",
          "这种克制让温暖变得可信。当角色在深夜的便利店里吃着一碗泡面，默默消化白天受的委屈，观众不会觉得被安慰，而是觉得被理解。",
          "被理解比被安慰更有力量。这也是韩国现实主义剧集能够跨越文化边界的原因。",
        ],
      },
      {
        id: "c2",
        title: "医疗剧为什么总在讲人，而不是病",
        summary: "最好的医疗剧，从来不是病理百科，而是关于尊严与选择的伦理现场。",
        date: "2026-09-03",
        author: "剧评人·老K",
        content: [
          "医疗是最容易拍出戏剧性的题材，也最容易拍得廉价。真正的差别在于：镜头究竟对准疾病，还是对准人。",
          "当一部医疗剧愿意花时间描述家属的犹豫、医生的疲惫、制度的无力，它就从类型剧升格成了社会观察。",
          "病会过去，但选择留下的重量，会跟着角色很久很久。",
        ],
      },
      {
        id: "c3",
        title: "阶层叙事：那些住在城市边缘的人",
        summary: "当镜头从豪宅转向半地下室，韩剧展现了一种不回避的勇气。",
        date: "2026-08-30",
        author: "韩剧观察笔记",
        content: [
          "阶层是韩国剧集最敏锐的触角之一。它不喊口号，只是安静地把不同阶层的人放到同一个空间里，然后让观众自己去体会那种无法言说的错位感。",
          "这种叙事的力量在于，它不控诉，只是呈现。而呈现本身，已经足够有力。",
          "当一部剧愿意直视那些住在城市边缘的人，它就不再只是娱乐产品，而是一面镜子。",
        ],
      },
    ],
  },
];